/**
 * 统一的 API 请求工具
 * 自动添加 Authorization header
 */

/**
 * 智能获取 API 基础地址
 * 自动检测环境：本地开发时连接 localhost:8001，生产环境使用配置的地址
 */
function getSmartApiBase(): string {
  // 服务端渲染时也使用空字符串（通过nginx代理）
  if (typeof window === "undefined") {
    return "";
  }

  // 客户端：检测是否为本地开发环境
  const hostname = window.location.hostname;
  const port = window.location.port;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // 本地开发环境，连接本地后端
    return "http://localhost:8001";
  }

  // 生产环境，使用空字符串（通过nginx代理到本地8001）
  return "";
}

const API_BASE = getSmartApiBase();

export function getApiBase() {
  return getSmartApiBase();
}

/**
 * 带认证的 fetch 请求
 */
export async function authFetch(
  path: string,
  token: string | null,
  options: RequestInit = {}
): Promise<Response> {
  const headers: HeadersInit = {
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)["Authorization"] = `Bearer ${token}`;
  }

  return fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
}

/**
 * GET 请求
 */
export async function apiGet(path: string, token: string | null): Promise<Response> {
  return authFetch(path, token);
}

/**
 * POST 请求
 */
export async function apiPost(
  path: string,
  token: string | null,
  body?: any
): Promise<Response> {
  return authFetch(path, token, {
    method: "POST",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
}

/**
 * PUT 请求
 */
export async function apiPut(
  path: string,
  token: string | null,
  body?: any
): Promise<Response> {
  return authFetch(path, token, {
    method: "PUT",
    headers: body ? { "Content-Type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
}

/**
 * DELETE 请求
 */
export async function apiDelete(path: string, token: string | null): Promise<Response> {
  return authFetch(path, token, {
    method: "DELETE",
  });
}
